import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ScalarResponseModel } from "../../models/scalar/scalar.model";

@Injectable({
    providedIn: 'root'
})
export class DistributorsTicketsCountService {

    private DISTRIBUTORSTICKETSCOUNT_URL = 'api/SupportTicketsCount/1' //  0 for All, 1 for Distrubtors, 2 for Customers

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    get url(): string {

        return this.DISTRIBUTORSTICKETSCOUNT_URL;
    }

    getDistributorsTicketsCount$(): Observable<ScalarResponseModel> {
        console.log("getDistributorsTicketsCount$");
        return this._httpClient.get<ScalarResponseModel>(this.DISTRIBUTORSTICKETSCOUNT_URL);
    }
}
